module.exports = __webpack_public_path__ + "media/images/icons/country_flags/ng-f29450b9f8b2f04e96aaa39902099e9c.svg";